import { CdkPortalOutlet } from '@angular/cdk/portal';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  HostBinding,
  HostListener,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { dynamicAnimations } from 'app/shared/animations/animations';
import { Subject } from 'rxjs';
import { ModalConfiguration, newModalConfiguration } from '../../models/modal.model';
import { DynamicLoaderService } from '../../services/dynamic-loader.service';
import { HttpLoadingIndicatorService } from 'app/core/services/http-loading-indicator.service';

@Component({
  selector: 'dynamic-dynamic-container',
  templateUrl: './dynamic-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [dynamicAnimations],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '[class]': 'modalConfiguration.panelClass',
  },
})
export class DynamicContainerComponent<C extends object> implements OnDestroy {
  @ViewChild('container', { read: CdkPortalOutlet, static: false })
  container?: CdkPortalOutlet;

  dynamicLoaderService?: DynamicLoaderService;
  containerId = 0;
  componentRef?: ComponentRef<C>;
  animationEnd = new Subject<boolean>();

  activeClass = false;

  modalConfiguration: ModalConfiguration = newModalConfiguration();

  isLoading = this.loadingService.loading$;

  constructor(
    public elementRef: ElementRef,
    private ref: ChangeDetectorRef,
    private loadingService: HttpLoadingIndicatorService
  ) {}

  @HostBinding('class.active') get a_class(): boolean {
    return this.activeClass;
  }

  @HostListener('document:click', ['$event'])
  clickEvent(event: any): void {
    if (this.modalConfiguration.outsideClick) {
      const clickedOutside = event.target === this.elementRef.nativeElement;
      if (clickedOutside) {
        this.close();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.componentRef) {
      this.dynamicLoaderService?.previousId();
      this.componentRef.destroy();
    }
  }

  onCloseClick(): void {
    this.close();
  }

  attachChildComponent(childComponent: any, data: any): void {
    this.ref.detectChanges();
    if (!this.container) {
      return;
    }
    if (this.container.hasAttached()) {
      return;
    }
    this.componentRef = this.container.attachComponentPortal(childComponent);
    Object.assign(this.componentRef.instance, data);
  }

  close(): void {
    this.startExitAnimation();
  }

  removeContainer(): void {
    if (!isNaN(this.containerId)) {
      this.dynamicLoaderService?.removeComponentFromBody(this.containerId);
    }
  }

  onAnimationDone(event: any): void {
    if (event.toState === 'exit') {
      this.removeContainer();
    }
    this.animationEnd.next(true);
  }

  onAnimationStart(event: any): void {
    this.activeClass = event.toState !== 'exit';
  }

  startExitAnimation(): void {
    this.modalConfiguration.animation = 'exit';
    this.activeClass = false;
    this.ref.markForCheck();
  }
}
